import React from "react";

import { AnimatedLogo } from "../components/AnimatedLogo";

const Loader = props => {
  const { msg } = props;
  const { loaderWrapper, title } = styles;
  return (
    <div style={loaderWrapper}>
      {msg ? <h3 style={title}>{msg}</h3> : null}
      <AnimatedLogo />
    </div>
  );
};

const styles = {
  loaderWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column"
  },
  title: {
    margin: "5px",
    fontSize: "14px",
    letterSpacing: "1px",
    fontWeight: "400",
    color: "#0076f4"
  }
};

export { Loader };
